module.exports = __webpack_public_path__ + "img/viandehachee.b54e1180.png";